import { render } from "./Header.vue?vue&type=template&id=0a1ec038&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0a1ec038"

export default script